import { useState } from 'react';
import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import { faqs } from '@/mocks/faqs';
import type { FaqItem } from '@/types/content';

const list = (faqs as FaqItem[]).slice(0, 4);

export default function FaqPreview() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <SectionHeading
          eyebrow="FAQ"
          title="常见问题"
          desc="关于更新节奏、栏目区别与订阅方式，先在这里找答案。还有疑问可以去常见问题页继续翻。"
          linkTo="/faq"
          linkLabel="查看全部问答"
        />
        <div className="max-w-3xl">
          <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
            {list.map((item, i) => {
              const isOpen = open === i;
              return (
                <div key={item.q} className="border-b border-background-200 last:border-0">
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? null : i)}
                      aria-expanded={isOpen}
                      className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-5 text-left hover:bg-background-100 transition-colors"
                    >
                      <span className="font-heading text-sm md:text-base font-bold text-foreground-950">
                        {item.q}
                      </span>
                      <span
                        className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-colors ${
                          isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                        }`}
                      >
                        <i className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-base`} aria-hidden="true"></i>
                      </span>
                    </button>
                  </h3>
                  {isOpen && (
                    <div className="px-5 md:px-6 pb-5 -mt-1">
                      <p className="text-sm text-foreground-600 leading-7">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          <p className="mt-5 text-sm text-foreground-500">
            没找到答案？
            <Link to="/faq" className="text-primary-600 font-medium hover:text-primary-700 ml-1 transition-colors">
              前往常见问题页
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
}